
import {collection, getDocs} from 'firebase/firestore';
import {db} from '../firebase';


import { Portfolio } from "../globalValues";

export default async function getPortfolio() {
    try {
        const tempList: Portfolio[] = [];

        const portfolio = await getDocs(collection(db, "Portfolio"));

        portfolio.forEach(doc => {
            const temp = {
                id: doc.id,
                type: doc.data().type,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });
        

        tempList.sort(function(a, b) { 
            var textA = a.type;
            var textB = b.type;
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        
        const d = new Date();
        sessionStorage.setItem("portfolio", JSON.stringify(tempList));
        localStorage.setItem("Last-Fetch-Time-Port", JSON.stringify(d.getTime()));

        console.log(tempList);

        
        return tempList;
    }
    catch(e) {
        console.log(e);
    }    
}

